// removed by extract-text-webpack-plugin
module.exports = {"title":"_1mbW2DzkzkfmFgq7tAvn2N","PaymentBox":"_3RScukFA_KbXGIaV99uy0S"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ChangePaymentDetailsDialog/ChangePaymentDetailsDialog.scss
// module id = 2736
// module chunks = 0